import React, { Component, Fragment } from 'react'
import { Select } from '@driftt/tide-selects'
import { IconButton, Div, H4 } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'
import { connect } from 'react-redux'
import SegmentProperty from './SegmentProperty'
import SegmentValue from './SegmentValue'

const joinSelectOptions = [{label: 'and', value: 'AND'}, {label: 'or', value: 'OR'}]

const mapStateToProps = state => ({
  contact: state.__CRM.filterBuilder.contact,
  events: state.__CRM.filterBuilder.events,
  playbookEvents: state.__CRM.filterBuilder.playbookEvents,
  playbookEventLibrary: state.__CRM.filterBuilder.playbookEventLibrary,
  tags: state.__CRM.filterBuilder.tags
})

class FilterViewer extends Component {
  changeGroupLevelJoin = (groupId, { value }) => {
    const { onChangeGroupJoin } = this.props

    onChangeGroupJoin(value, groupId)
  }

  changeTopLevelJoin = ({ value }) => {
    const { onChangeTopJoin } = this.props

    onChangeTopJoin(value)
  }

  getRenderedProperty = (filter) => {
    const reduxStore = filter.segmentProperty.subEntityType

    const findProp = prop => prop.name === filter.segmentProperty.name

    if (reduxStore === 'playbookEvents') {
      return this.props.playbookEventLibrary.filter(findProp)[0]
    } else {
      return this.props[reduxStore].filter(findProp)[0]
    }
  }

  renderFilters = (filters, matchType, groupIndex) => {
    const { onAddFilter, onDeleteFilter, onEditFilterProperty, onEditFilterValue } = this.props
    
    filters.map((f) => f.operator === 'HAS_OCCURRED_EXACTLY' ? f.segmentValue.type = 'NUMERIC' : f.segmentValue.type)
    filters.map((f) => f.segmentValue.type === 'NUMERIC' && f.segmentValue.value === null ?  f.segmentValue.value  = 0  : f.segmentValue.value)

    return (
      <Fragment>
        {
          filters.map((filter, filterIndex) => {
            return (
              <Fragment key={`filter-viewer--group-${groupIndex}-filter-${filterIndex}`}>
                <Div className="filter-builder-viewer--filter-row">
                  <SegmentProperty
                    onClick={() => onEditFilterProperty({ groupIndex, filterIndex, selectedFilter: filter })}
                    propertyDef={this.getRenderedProperty(filter)}
                    groupId={groupIndex}
                    filterId={filterIndex}
                  />
                  <IconButton
                    className="filter-builder-viewer--delete-filter"
                    icon="trash"
                    size="small"
                    onClick={() => onDeleteFilter(groupIndex, filterIndex)}
                  />
                  <SegmentValue
                    onClick={() => onEditFilterValue({ groupIndex, filterIndex, selectedFilter: filter })}
                    operator={filter.operator}
                    value={filter.segmentValue.value}
                    type={filter.segmentValue.type}
                    subType={filter.segmentProperty.subEntityType}
                  />
                </Div>
                {filterIndex === 0 &&
                  <Div className="filter-builder-viewer--filter-row--join">
                    <Select
                      defaultValue={{label: matchType.toLowerCase(), value: matchType }}
                      options={joinSelectOptions}
                      onChange={(value) => this.changeGroupLevelJoin(groupIndex, value)}
                      size='small'
                      className="filter-builder-joiner-select"
                    />
                  </Div>
                }
                {(filterIndex > 0 && filterIndex !== filters.length) &&
                  <Div className="filter-builder-viewer--filter-row--join filter-builder-viewer--row-join--noselect">
                    {matchType.toLowerCase()}
                  </Div>
                }
              </Fragment>
            )
          })
        }
        <Div
          className="filter-builder-viewer--filter-add"
          onClick={() => onAddFilter({ groupIndex })}
        >
          <Icon name="plus" width={10} /> 
          Add filter
        </Div>
      </Fragment>
    )
  }

  renderGroups = () => {
    const { currentSegment, onAddGroup } = this.props

    return (
      <Fragment>
        {currentSegment.segmentGroups.map((segmentGroup, groupIndex) => {
          return (
            <Fragment key={`filter-viewer--group-${groupIndex}`}>
              <Div className="filter-builder-viewer--group">
                {this.renderFilters(segmentGroup.filters, segmentGroup.matchType, groupIndex)}
              </Div>
              {(groupIndex === 0) &&
                <Div className="filter-builder-viewer--group-join">
                  <Select
                    defaultValue={{label: currentSegment.matchType.toLowerCase(), value: currentSegment.matchType }}
                    options={joinSelectOptions}
                    onChange={this.changeTopLevelJoin}
                    size='small'
                    className="filter-builder-joiner-select"
                  />
                </Div>
              }
              {(groupIndex > 0 && groupIndex !== currentSegment.segmentGroups.length) &&
                <Div className="filter-builder-viewer--group-join filter-builder-viewer--group-join--noselect">
                  {currentSegment.matchType.toLowerCase()}
                </Div>
              }
            </Fragment>
          )
        })}
        <Div className="filter-builder-viewer--group--add-filter" onClick={onAddGroup}>
          <Icon name="plus" width={10} /> 
          Add another group
        </Div>
      </Fragment>
    )
  }
  render() {
    const { currentSegment } = this.props

    return (
      <Div className="filter-builder-viewer">
        <H4 className="filter-builder-viewer-title">Show me contacts for whom...</H4>
        {currentSegment && this.renderGroups()}
      </Div>
    )
  }
}

export default connect(mapStateToProps)(FilterViewer)
